import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _CloudLightningIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        d="M0.587786 5.78571C1.9865 2.12775 5.59012 -0.20584 9.50019 0.0143373C13.1473 0.21971 16.2801 2.60299 17.4796 5.99981H18.0013C20.8397 6.00315 23.2875 7.99508 23.8676 10.7736C24.4476 13.5522 23.0013 16.3571 20.4013 17.4958C19.8954 17.7174 19.3056 17.4869 19.0841 16.981C18.8625 16.4751 19.093 15.8854 19.5989 15.6638C21.3323 14.9047 22.2965 13.0347 21.9098 11.1824C21.5231 9.33011 19.8914 8.00222 17.9993 7.99981H16.7401C16.2841 7.99981 15.8859 7.69135 15.7718 7.24985C15.0102 4.30062 12.4289 2.18242 9.38774 2.01117C6.34658 1.83992 3.54376 3.65494 2.45588 6.50002C1.36799 9.3451 2.24479 12.5671 4.62435 14.4686C5.0558 14.8134 5.12607 15.4426 4.7813 15.8741C4.43653 16.3055 3.80727 16.3758 3.37582 16.031C0.316386 13.5862 -0.810924 9.44368 0.587786 5.78571Z"
        fill={iconColor}
      />
      <Path
        d="M13.8321 11.5545C14.1384 11.095 14.0142 10.4741 13.5547 10.1678C13.0952 9.8614 12.4743 9.98557 12.168 10.4451L8.16795 16.4451C7.96338 16.752 7.94431 17.1465 8.11833 17.4717C8.29235 17.7968 8.63121 17.9998 9 17.9998H13.1315L10.168 22.4451C9.8616 22.9046 9.98577 23.5255 10.4453 23.8319C10.9048 24.1382 11.5257 24.014 11.8321 23.5545L15.8321 17.5545C16.0366 17.2476 16.0557 16.8531 15.8817 16.5279C15.7077 16.2028 15.3688 15.9998 15 15.9998H10.8685L13.8321 11.5545Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const CloudLightningIcon = assignWithoutSideEffects(_CloudLightningIcon, {
  componentId: 'CloudLightningIcon',
});

export default CloudLightningIcon;
